/**
 * ReSettlement Helpers
 * 재마감 페이지 관련 헬퍼 함수 및 상수
 */

// ======== 타입 ========

/** 필터 상태 타입 */
export type FilterState = {
    tableName: string;
    settlementDate: string;
};

// ======== 상수 ========

/** 초기 필터 상태 */
export const INITIAL_FILTERS: FilterState = {
    tableName: '',
    settlementDate: '',
} as const;

// ======== 헬퍼 함수 ========

/**
 * 오늘 날짜를 YYYY-MM-DD 형식으로 반환
 */
export const getTodayDate = (): string => {
    const today = new Date();
    return today.toISOString().split('T')[0];
};

